/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.13"
        height="119.1"
        viewBox="0 0 82.13 119.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M19.82 62.43a1.24 1.24 0 0 1 1.24 1.12v54.3a1.24 1.24 0 0 1-1.12 1.24H1.24a1.25 1.25 0 0 1-.13-2.49h17.46V64.93H1.25a1.24 1.24 0 0 1-1.24-1.12v-.13a1.24 1.24 0 0 1 1.12-1.24h18.7Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M74.77 79.86a7.371 7.371 0 0 1 .24 14.74h-8.16a1.252 1.252 0 0 1-.13-2.5h8a4.871 4.871 0 0 0 .21-9.74H66.8a1.25 1.25 0 0 1-.13-2.49h8Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M73.85 92.11a7.371 7.371 0 0 1 .24 14.74h-7.25a1.25 1.25 0 0 1-.13-2.49h7.14a4.871 4.871 0 0 0 .21-9.74h-7.22a1.252 1.252 0 0 1-.13-2.5h7.14Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M70.33 104.35a7.38 7.38 0 0 1 .25 14.75H31.77a6.56 6.56 0 0 1-4.46-1.73l-.21-.21-1.93-1.97a1.62 1.62 0 0 0-1-.47h-4.34a1.25 1.25 0 0 1-.13-2.49h4.31a4.06 4.06 0 0 1 2.74 1.05l.17.16 1.93 1.93a4 4 0 0 0 2.68 1.2h38.78a4.871 4.871 0 0 0 .22-9.74h-3.71a1.25 1.25 0 0 1-.13-2.49h3.62Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M16.09 15.06a1.26 1.26 0 0 1 1.67 0l.1.1 14.09 15.13a1.25 1.25 0 0 1-1.73 1.79l-.1-.09-14.09-15.13a1.25 1.25 0 0 1 .06-1.8Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M71.9 15.13a1.25 1.25 0 0 1 1.77-.07 1.27 1.27 0 0 1 .15 1.67l-.09.1-14.1 15.13a1.25 1.25 0 0 1-1.91-1.6l.08-.1Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M44.86 0a1.24 1.24 0 0 1 1.24 1.12v23.41a1.24 1.24 0 0 1-1.24 1.25 1.26 1.26 0 0 1-1.25-1.12V1.25A1.25 1.25 0 0 1 44.86 0Z"
          className="icon-fill icon-accent"/><path
          fill="#fff"
          d="M44.43 30.19a7.11 7.11 0 0 1 6 3.38 13.34 13.34 0 0 1 1.43 3.44c.88 3.32.67 6.81-.68 12.29l-.25 1-.26 1-.38 1.41-.23.86-.21.82-.18.78-.09.38-.16.73c-.67 3.21-.74 5.4-.12 7.12l.07.19.08.22.08.19.11.25a6.68 6.68 0 0 0 .95 1.38 6.25 6.25 0 0 0 4.64 2h18.04a7.371 7.371 0 0 1 .25 14.74h-6.68a1.25 1.25 0 0 1-.13-2.49h6.56a4.871 4.871 0 0 0 .22-9.74h-18a8.86 8.86 0 0 1-6.8-2.83 8.07 8.07 0 0 1-1.67-2.73v-.11l-.07-.18a13.19 13.19 0 0 1-.29-7l.13-.71c.07-.36.15-.74.23-1.13l.18-.79.2-.83.22-.86.24-.91.38-1.41.25-.94.12-.46.22-.88.19-.84a3.38 3.38 0 0 0 .09-.41l.17-.79c.75-3.74.78-6.3.16-8.66a10.72 10.72 0 0 0-1.14-2.75 4.59 4.59 0 0 0-3.83-2.21c-2.46 0-4.13 1.5-4.69 4.51-3.62 17.28-10.59 27.7-19.36 31.85a1.25 1.25 0 0 1-1.07-2.26c8-3.78 14.51-13.53 18-30.07.7-4.15 3.42-6.55 7.08-6.55Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThumbsUpIcon';

export default Icon;
